module.exports = __webpack_public_path__ + "static/media/gender-favorite.434cbeac.PNG";